import { Product } from "@models";
import PricingRecord, { PricingSettings } from "@models/PricingRecord";
import { endOfDay, startOfDay } from "date-fns";
import _ from "lodash";
import { escapeCategoryId, unescapeCategoryId } from ".";

export function initialPricingSettings(
	pricingSettings: PricingSettings,
	products: Product[]
): PricingSettings {
	const productsByKeyObj: PricingRecord["feePerModuleAndEmployee"] =
		products.reduce(
			(prev: PricingRecord["feePerModuleAndEmployee"], cur: Product) => ({
				...prev,
				[cur["id"]]: { type: null, amount: null },
			}),
			{}
		);

	return pricingSettings.map((pricingRecord: PricingRecord) => {
		const clonedRecord = structuredClone(pricingRecord);
		if (clonedRecord.feePerModuleAndEmployee) {
			return {
				...clonedRecord,
				feePerModuleAndEmployee: _.mapKeys(
					{
						...productsByKeyObj,
						...clonedRecord.feePerModuleAndEmployee,
					},
					(_, key) => escapeCategoryId(key)
				),
			};
		}
		return clonedRecord;
	});
}

export function checkPricingSettings(
	pricingSettings: PricingSettings
): PricingSettings {
	return pricingSettings.map((pricingRecord: PricingRecord) => {
		const clearedFeePerModuleAndEmployee: PricingRecord["feePerModuleAndEmployee"] =
			{};
		if (pricingRecord.feePerModuleAndEmployee !== null) {
			for (const key in pricingRecord.feePerModuleAndEmployee) {
				const item = pricingRecord.feePerModuleAndEmployee[key];
				if (item.type !== null && item.type !== undefined) {
					const unescapedKey = unescapeCategoryId(key);
					clearedFeePerModuleAndEmployee[unescapedKey] = item;
				}
			}
		}
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		const { id, ...pricingRecordWithoutId } = pricingRecord;
		return {
			...pricingRecordWithoutId,
			availableFrom:
				pricingRecordWithoutId.availableFrom &&
				startOfDay(pricingRecordWithoutId.availableFrom),
			availableUntil:
				pricingRecordWithoutId.availableUntil &&
				endOfDay(pricingRecordWithoutId.availableUntil),
			feePerModuleAndEmployee: clearedFeePerModuleAndEmployee,
		};
	});
}
